
<div class="container"  *ngIf="userName !== 'Elite Shipping'">
  <iframe
    class="database"
    src="https://lookerstudio.google.com/embed/reporting/079b06b9-6e38-449b-b999-fcb2edcaa190/page/E973D"
    frameborder="0"
    style="border: 0"
    allowfullscreen
    sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
  ></iframe>
</div>
<div class="container" *ngIf="userName === 'Elite Shipping'">
  <iframe
    class="database"
    src="https://lookerstudio.google.com/embed/reporting/b0ce722f-e492-4e64-9f64-ec6d8ab3ce64/page/cIVLE"
    frameborder="0"
    style="border: 0"
    allowfullscreen
    sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
  ></iframe>
</div>


